define('view/finder/base.finder.view',['require','exports','module','underscore','marionette','uikit/uikit','fukit','templates','blockit'],function(require, exports, module) {
  //prettier-ignore
  var _                             = require('underscore'),
      Mn                            = require('marionette'),
      UIKit                         = require('uikit/uikit'),
      FetchResourcesOnEventBehavior = require('fukit').FetchResourcesOnEventBehavior,
      Templates                     = require('templates'),
      BlocKit                       = require('blockit');

  var EnableOnlyWhenSelectableRecordBehavior = Mn.Behavior.extend({
    defaults: {
      maxAnswerMultiplicity: null,
      answerCollection: null,
    },

    onFirstRender: function() {
      this.updateDisabled();
      this.listenTo(this.getOption('answerCollection'), 'update reset', this.updateDisabled);
    },

    updateDisabled: function() {
      this.view.disabled = !this.canSelectRecord(this.view.model);
    },

    canSelectRecord: function(model) {
      var answerCollection = this.getOption('answerCollection');
      return answerCollection.get(model) || this.hasMaxAnswerMultiplicityBeenReached() ? false : true;
    },

    hasMaxAnswerMultiplicityBeenReached: function() {
      return BaseFinderView.hasMaxAnswerMultiplicityBeenReached(
        this.getOption('maxAnswerMultiplicity'),
        this.getOption('answerCollection')
      );
    },
  });

  var BaseFinderView = UIKit.ItemView.extend(
    {
      className: 'ui segment basic',
      template: Templates.App['base.finder'],

      options: {},

      internalViewOptions: {
        searchTableView: function() {
          var filters = this.getOption('filters');

          return {
            type: BlocKit.SearchablePageableTableView,
            searchFields: this.getOption('searchFields'),
            filters: [].concat(this.getSearchFilters()).concat(_.isArray(filters) ? filters : []),
            simplePagination: true,
            collection: this.getSearchCollection(),
            table: {
              childView: UIKit.Table.RowView.extend({
                childView: UIKit.Table.CellView.extend({
                  attributes: {
                    style: 'cursor: pointer;',
                  },
                }),
              }),
              childViewOptions: {
                behaviors: {
                  EnableOnlyWhenSelectableRecordBehavior: {
                    answerCollection: this.selectedCollection,
                    maxAnswerMultiplicity: this.getOption('maxAnswerMultiplicity'),
                    behaviorClass: EnableOnlyWhenSelectableRecordBehavior,
                  },
                  InvokeMethodOnEventBehavior: {
                    eventName: 'press',
                    method: this.addSelectedSearchRowToSelectedCollection,
                    context: this,
                    behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                  },
                },
              },
              focusable: false,
              selectable: true,
              emptyText: this.getOption('emptyText') || 'Use the search box above to find records.',
              behaviors: {
                FetchResourcesOnEventBehavior: {
                  resources: [this.getSearchCollection()],
                  eventName: 'first:render',
                  behaviorClass: FetchResourcesOnEventBehavior,
                },
              },
            },
          };
        },
        selectedTableHeaderView: function() {
          return {
            type: UIKit.Header,
            text: 'Selected Records',
            size: 'small',
          };
        },
        selectedTableView: function() {
          return {
            type: UIKit.Table,
            collapsing: true,
            collection: this.getOption('selectedCollection'),
            columns: this.getOption('columns'),
          };
        },
      },

      initialize: function() {
        UIKit.ItemView.prototype.initialize.apply(this, arguments);

        this.getSearchCollection().paginate.size(5);
      },

      onInjectedSearchTableView: function() {
        var thisTable = this;
        var addButtonColumn = {
          collapsing: true,
          childView: UIKit.Button,
          childViewOptions: {
            icon: 'add',
            inline: true,
            color: 'blue',
            behaviors: {
              EnableOnlyWhenSelectableRecordBehavior: {
                answerCollection: this.getOption('selectedCollection'),
                maxAnswerMultiplicity: this.getOption('maxAnswerMultiplicity'),
                behaviorClass: EnableOnlyWhenSelectableRecordBehavior,
              },
              InvokeMethodOnEventBehavior: {
                eventName: 'press',
                method: this.addSelectedSearchRowToSelectedCollection,
                context: this,
                behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
              },
            },
          },
        };
        this.searchTableView.addColumn(addButtonColumn);
      },

      onInjectedSelectedTableView: function() {
        var self = this;
        var removeButtonColumn = {
          collapsing: true,
          childView: UIKit.Button,
          childViewOptions: {
            icon: 'remove',
            inline: true,
            color: 'red',
            behaviors: {
              InvokeMethodOnEventBehavior: {
                eventName: 'press',
                method: this.removeSelectedSearchRowFromSelectedCollection,
                context: this,
                behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
              },
            },
          },
        };

        this.selectedTableView.columns.add(removeButtonColumn);
      },

      addSelectedSearchRowToSelectedCollection: function(model) {
        this.selectedCollection.add(model);
      },

      removeSelectedSearchRowFromSelectedCollection: function(model) {
        var self = this;
        // If you don't defer, the target gets removed and modal.js thinks you're clicking the dimmer and closes the modal.
        _.defer(function() {
          self.selectedCollection.remove(model);
        });
      },

      getSearchCollection: function() {
        if (this.getOption('searchCollection')) {
          return this.getOption('searchCollection');
        } else if (this.getOption('searchCollectionClass')) {
          var collectionClass = this.getOption('searchCollectionClass');
          var collection = new collectionClass();
          this.options.searchCollection = collection;
          return collection;
        }
      },

      //override this function when necessary
      getSearchFilters: function() {
        return [{ field: 'active', value: true, hidden: true }];
      },

      getSearchCollectionFilters: function() {
        return this.searchCollectionFilters;
      },
    },
    {
      hasMaxAnswerMultiplicityBeenReached: function(maxAnswerMultiplicity, answerCollection) {
        return maxAnswerMultiplicity != null && maxAnswerMultiplicity == answerCollection.length;
      },
    }
  );

  BaseFinderView.EnableOnlyWhenSelectableRecordBehavior = EnableOnlyWhenSelectableRecordBehavior;

  module.exports = BaseFinderView;
});

